module.exports = __webpack_public_path__ + "media/images/lupa-7a5f6946c5d147385233675e57aea98e.svg";